import { FormDataAPIType } from 'components/common/form';
import React, { useState } from 'react';
import IconMi from 'components/common/icon/IconMi';
import FormToggleButton from 'components/common/form/layout/control/FormToggleButton';
import { alpha } from '@mui/material';

export default function EditPanelToggleButton({
    elementProps,
    name,
    icon,
    isYNValues = false,
}: {
    elementProps: FormDataAPIType;
    name: string;
    icon?: string;
    isYNValues?: boolean;
}) {
    const [state, setState] = useState(0);
    const getCurrentValue = () => {
        const value = elementProps.form.hookFormGetValues(name) ?? false;
        return isYNValues ? value == 'Y' : value;
    };
    const handleChange = () => {
        const newValue = !getCurrentValue();
        elementProps.form.hookFormSetValue(name, isYNValues ? (newValue ? 'Y' : 'N') : newValue);
        setState((prev) => prev + 1);
    };
    const value = getCurrentValue();

    return (
        <FormToggleButton
            value={value}
            sx={{
                px: 0,
                minWidth: (theme) => theme.size.defaultHeight,
                '&.Mui-selected': {
                    borderColor: 'text.primary',
                    backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                },
            }}
            selected={value}
            onChange={handleChange}
        >
            <IconMi icon={icon} fontSize={'16'} sx={{ color: 'text.primary' }} />
        </FormToggleButton>
    );
}
